import {createContext} from "react";

export const NotificationContext = createContext({
    toasts: [],
    setToasts: () => {},
    addToast: () => {},
    removeToast: () => {}
});
